export default __webpack_public_path__ + "2514cf47f5c5d627ee165df5b570546e.svg";